export default __webpack_public_path__ + "static/media/logo_home_reg.c208e32b.jpg";